// Ordering helper for candidate work-experience lists.
//
// An entry missing either `from_date` or `to_date` can't be placed on the
// timeline, so it should never lead the list — it's pushed to the end while the
// rest keep their original relative order (Array.prototype.sort is stable).
// The current role is exempt: an ongoing job has no `to_date` by design
// ("Present"), which is not a missing-data gap, so it stays where it is.
const isIncomplete = (exp) =>
  !exp?.is_current && (!exp?.from_date || !exp?.to_date);

export const sortWorkExperiences = (list) => {
  if (!Array.isArray(list)) return [];
  return [...list].sort(
    (a, b) => Number(isIncomplete(a)) - Number(isIncomplete(b))
  );
};

export default sortWorkExperiences;
